import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import {setFavicon} from "./app/utils";

console.log(environment);

if (environment.production) {
  enableProdMode();
}

/*if (environment.prodStyle) {
  setFavicon();
}*/

platformBrowserDynamic().bootstrapModule(AppModule);



// WEBPACK FOOTER //
// /opt/app/develop/src/main.ts